import React from 'react';
import PropTypes from "prop-types";
import { Form } from "reactstrap";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import Loader from "../../../common/Loader";
import FormFooter from "../../../common/forms/FormFooter";
import ServiceTypeFormFields from './ServiceTypeFormField';

export const ServiceTypeForm = ({
  handleSubmit,
  loading,
  initialValues,
}) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <ServiceTypeFormFields
        initialValues={initialValues}
      />
      <FormFooter />
    </Form>
  );
};

ServiceTypeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({}),
};

ServiceTypeForm.defaultProps = {
  initialValues: null,
};

const mapStateToProps = (state) => ({
  loading: !state.BusUnit.ServiceType.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'ServiceTypeForm',
})(ServiceTypeForm);

export default connect(mapStateToProps)(formComponent);